export const getTimeAgo = (dateString) => {
    const now = new Date();
    const pastDate = new Date(dateString);
    const diffInMs = now.getTime() - pastDate.getTime(); // Difference in milliseconds
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInSeconds < 60) {
        return "Moments ago";
    } else if (diffInMinutes < 60) {
        return `${diffInMinutes} Minute${diffInMinutes > 1 ? "s" : ""} ago`;
    } else if (diffInHours < 24) {
        return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} ago`;
    } else if (diffInDays < 2) {
        // Format time for yesterday
        const formattedTime = pastDate.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
        });
        return `Yesterday at ${formattedTime}`;
    } else {
        // Default to showing the full date if more than 48 hours
        return pastDate.toLocaleDateString([], {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    }
};
